import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Bottom Heavy / Core' second='Workout 07' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Glutes / Quads',
							value: 'Air Squat',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Leg - Lifts',
						},
						{
							header: 'Sec / Minutes',
							value: '45 sec',
						},
					],
					[
						{
							header: '(A) Glutes / Quads',
							value: 'Plyo  Lunges',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Flutter Kicks',
						},
						{
							header: 'Sec / Minutes',
							value: '25 sec',
						},
					],
					[
						{
							header: '(A) Glutes / Quads',
							value: 'Curtsey Lunges',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Cross Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Glutes / Quads',
							value: 'Side Step',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Plank Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Glutes / Quads',
							value: 'Kneeling Hip Thrusts',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
